/**
 * Add functionality to forms.
 *
 */

/**
 * Helper to hide all forms.
 * @param boolean itemsOnly - If true, only hide the items in the form.
 */
function hideForms(itemsOnly = false) {
  const selector = itemsOnly ? '.wpcf7-form ol' : '.wpcf7-form';
  document.querySelectorAll(selector).forEach((form) => {
    // eslint-disable-next-line no-param-reassign
    form.style.display = 'none';
  });
}

/**
 * Helper to scroll back to the top of the form.
 * @param number extraOffset - Extra offset to add to the scroll position.
 */
function scrollBack(extraOffset = 0) {
  window.scrollTo({
    top: document.querySelector('main').getBoundingClientRect().top + window.pageYOffset + extraOffset,
    behavior: 'smooth',
  });
}

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Show the form that matches the selected value.
   * @param string selectedValue
   */
  function showForm(selectedValue) {
    hideForms();
    const selectedForm = document.querySelector(`#${selectedValue}-form`);
    if (selectedForm) selectedForm.style.display = 'block';
  }

  /**
   * Set the radio button based on the query string.
   */
  function setRadioButtonFromQuery() {
    const urlParams = new URLSearchParams(window.location.search);
    let showValue = urlParams.get('show');

    // Currently, there are hard-coded links to forms, so we have to map them.
    const mapping = {
      'spread-the-word': 'contact-341',
      'share-your-story': 'contact-342',
    };

    if (showValue && mapping[showValue]) {
      showValue = mapping[showValue];

      const radioButton = document.querySelector(`.contact-btn-group input[type="radio"][value="${showValue}"]`);
      if (radioButton) {
        radioButton.checked = true;
        showForm(showValue);
      }
    } else {
      // Default to the first radio button.
      const firstRadioButton = document.querySelector('.contact-btn-group input[type="radio"]');
      if (firstRadioButton) {
        firstRadioButton.checked = true;
        showForm(firstRadioButton.value);
      }
    }
  }

  // Add event listener to our radio buttons.
  document.querySelectorAll('.contact-btn-group input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', (event) => {
      if (event.target.checked) {
        showForm(event.target.value);
      }
    });
  });

  setRadioButtonFromQuery();
});

/**
 * Handle successful form submission.
 */
document.addEventListener('wpcf7mailsent', (event) => {
  hideForms(true);
  document.querySelector('.contact-btn-group-section').style.display = 'none';

  const prefix = `wpcf7-f${event.detail.contactFormId}`;
  const element = document.querySelector(`[id^="${prefix}"] .wpcf7-response-output`);

  if (element) {
    element.style.display = 'block';
    scrollBack();
  }
}, false);

/**
 * Handle invalid form submission.
 */
document.addEventListener('wpcf7invalid', () => {
  scrollBack(180);
}, false);

jQuery(($) => {
  if ($('body').hasClass('page-educators')) {
    $('#educator-registration-form-3 input[type=submit]').prop('disabled', true);

    if ($('#swpm-114-0').prop('checked') == true) {
      $('#educator-registration-form-3 input[type=submit]').prop('disabled', false);
    }

    $('#swpm-114-0').on('change', function () {
      if ($(this).prop('checked') == true) {
        $('#educator-registration-form-3 input[type=submit]').prop('disabled', false);
      } else if ($(this).prop('checked') == false) {
        $('#educator-registration-form-3 input[type=submit]').prop('disabled', true);
      }
    });
  }

  if ($('body').hasClass('page-employers')) {
    $('#employer-registration-form-5 input[type=submit]').prop('disabled', true);

    if ($('#swpm-110-0').prop('checked') == true) {
      $('#educator-registration-form-3 input[type=submit]').prop('disabled', false);
    }

    $('#swpm-110-0').on('change', function () {
      if ($(this).prop('checked') == true) {
        $('#employer-registration-form-5 input[type=submit]').prop('disabled', false);
      } else if ($(this).prop('checked') == false) {
        $('#employer-registration-form-5 input[type=submit]').prop('disabled', true);
      }
    });
  }

  if ($('body').hasClass('page-resource-submission')) {
    document.addEventListener('wpcf7mailsent', () => {
      $('.wpcf7-response-output').show();
      $('#wpcf7-f933-p934-o1 ol').hide();
      $('html, body').stop().animate({
        scrollTop: $('#wpcf7-f933-p934-o1').offset().top - 180,
      }, 900, 'swing');
    }, false);

    document.addEventListener('wpcf7invalid', () => {
      $('html, body').stop().animate({
        scrollTop: $('#wpcf7-f933-p934-o1').offset().top - 180,
      }, 900, 'swing');
    }, false);
  }
});
